import axios from 'App/axios';

// TODO(BKG-147): sunset when banking reaches 100% — remove along with the /admin/banking/partial-transfer-enabled endpoint
type IsPartialTransferEnabledType = (storeId: string) => Promise<boolean>;

const isPartialTransferEnabled: IsPartialTransferEnabledType = async (
  storeId,
) => {
  const response = await axios.get<{ enabled: boolean }>(
    `/admin/banking/partial-transfer-enabled/${storeId}`,
  );
  return response.data.enabled;
};

type IsBankingEnabledType = (storeId: string) => Promise<boolean>;

const isBankingEnabled: IsBankingEnabledType = async (storeId) => {
  const response = await axios.get<{ enabled: boolean }>(
    `/admin/banking/enabled/${storeId}`,
  );
  return response.data.enabled;
};

interface BankingServiceInterface {
  isPartialTransferEnabled: IsPartialTransferEnabledType;
  isBankingEnabled: IsBankingEnabledType;
}

const bankingService: BankingServiceInterface = {
  isPartialTransferEnabled,
  isBankingEnabled,
};

export default bankingService;
